import { createSelector } from 'reselect';
import { gate } from 'hub-http/gates';
import { debugGate, isQa } from '../utils/env';
const ASSET_SEARCH_CHIRP_MIGRATION = gate('Marketplace:AssetSearch:ChirpMigration');
const getGates = state => state.auth.gates;
const getPortal = state => state.auth.portal;
const getUser = state => state.auth.user;
export const selectPortalScopes = state => state.auth.portal.scopes;
export const selectUserScopes = state => state.auth.user.scopes;
export const getAuth = state => state.auth;
export const getIsCustomer = createSelector([getPortal], portal => !!(portal && portal.portal_id));
export const getIsPublic = createSelector([getIsCustomer], isCustomer => !isCustomer);
export const getIsUngatedForAssetSearchChirp = createSelector([getGates, getIsPublic], (gates, isPublic) => isPublic && isQa() || gates.includes(ASSET_SEARCH_CHIRP_MIGRATION) || debugGate(ASSET_SEARCH_CHIRP_MIGRATION));
export const getUserFirstName = createSelector([getUser], user => user.first_name);
export const getUserLastName = createSelector([getUser], user => user.last_name);
export const getUserEmail = createSelector([getUser], user => user.email);
export const getUserId = createSelector([getUser], user => user.user_id);
export const getHasZorseWebticketScope = createSelector([selectUserScopes], scopes => scopes.includes('zorse-webticket'));